module.exports = __webpack_public_path__ + "media/images/wttest1-c1bef4d49f6bd61949fca6109599d2fd.png";